
    <template>
      <section class="content element-doc">
        <h2 id="biao-ge-wen-ben-ge-shi-hua"><a class="header-anchor" href="#biao-ge-wen-ben-ge-shi-hua">¶</a> 表格文本格式化</h2>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa">¶</a> 基础用法</h3>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;sh-table :data=&quot;tableList&quot; :pageShow=&quot;false&quot;&gt;
      &lt;el-table-column v-for=&quot;item in columnList&quot; :prop=&quot;item.key&quot; :key=&quot;item.key&quot; :label=&quot;item.title&quot;&gt;
        &lt;template slot-scope=&quot;{ row }&quot;&gt;
          &lt;template v-if=&quot;item.key === 'num'&quot;&gt;
            &lt;ShTableColumnFormat :value=&quot;row[item.key]&quot; :type=&quot;item.type&quot;&gt; &lt;/ShTableColumnFormat&gt;
          &lt;/template&gt;
          &lt;template v-else&gt;
            &lt;span&gt;{{ row[item.key] }}&lt;/span&gt;
          &lt;/template&gt;
        &lt;/template&gt;
      &lt;/el-table-column&gt;
    &lt;/sh-table&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        tableList: [
          {
            name: '张三',
            age: 18,
            num: 0.52418
          }
        ]
      }
    },
    computed: {
      columnList() {
        return [
          {
            title: '姓名',
            key: 'name',
            type: 'string',
            width: 100,
            minWidth: 100,
            align: 'center',
            headerAlign: 'center'
          },
          {
            title: '年龄',
            key: 'age',
            type: 'number',
            width: 100,
            minWidth: 100,
            align: 'right',
            headerAlign: 'center'
          },
          {
            title: '数字',
            key: 'num',
            type: 'percentage',
            width: 100,
            minWidth: 100,
            align: 'right',
            headerAlign: 'center'
          }
        ]
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="shu-xing"><a class="header-anchor" href="#shu-xing">¶</a> 属性</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td>需要格式化的值</td>
<td>string,number,boolean</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>type</td>
<td>格式化类型</td>
<td>string</td>
<td>详见预设格式参数</td>
<td>string</td>
</tr>
</tbody>
</table>
<h3 id="yu-she-ge-shi-can-shu"><a class="header-anchor" href="#yu-she-ge-shi-can-shu">¶</a> 预设格式参数</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
</tr>
</thead>
<tbody>
<tr>
<td>string</td>
<td>默认类型,不做任何处理,可不传</td>
<td>string</td>
</tr>
<tr>
<td>point</td>
<td>数字千分位,保留小数位</td>
<td>number</td>
</tr>
<tr>
<td>price-float1</td>
<td>数字千分位,保留 2 位小数,四舍五入,0 显示</td>
<td>number</td>
</tr>
<tr>
<td>point-int</td>
<td>数字千分位,保留整数</td>
<td>number</td>
</tr>
<tr>
<td>point-int1</td>
<td>数字千分位,四舍五入取整,为 0 显示 -</td>
<td>number</td>
</tr>
<tr>
<td>point-int2</td>
<td>数字千分位,四舍五入取整,为 0 显示 0</td>
<td>number</td>
</tr>
<tr>
<td>point-part</td>
<td>数字千分位,保留 2 位小数,四舍五入</td>
<td>number</td>
</tr>
<tr>
<td>percentage</td>
<td>百分比,保留 2 位小数,四舍五入</td>
<td>number</td>
</tr>
<tr>
<td>percentageNo</td>
<td>百分比,保留 2 位小数</td>
<td>number</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('sh-table',{attrs:{"data":_vm.tableList,"pageShow":false}},_vm._l((_vm.columnList),function(item){return _c('el-table-column',{key:item.key,attrs:{"prop":item.key,"label":item.title},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(item.key === 'num')?[_c('ShTableColumnFormat',{attrs:{"value":row[item.key],"type":item.type}})]:[_c('span',[_vm._v(_vm._s(row[item.key]))])]]}}],null,true)})}),1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        tableList: [
          {
            name: '张三',
            age: 18,
            num: 0.52418
          }
        ]
      }
    },
    computed: {
      columnList() {
        return [
          {
            title: '姓名',
            key: 'name',
            type: 'string',
            width: 100,
            minWidth: 100,
            align: 'center',
            headerAlign: 'center'
          },
          {
            title: '年龄',
            key: 'age',
            type: 'number',
            width: 100,
            minWidth: 100,
            align: 'right',
            headerAlign: 'center'
          },
          {
            title: '数字',
            key: 'num',
            type: 'percentage',
            width: 100,
            minWidth: 100,
            align: 'right',
            headerAlign: 'center'
          }
        ]
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  